// src/services/authService.js
import apiClient from './api';

export const loginUser = async (identifier, password) => {
  console.log('authService: Attempting login for identifier:', identifier);
  try {
    const response = await apiClient.post('/account/login/', {
      username: identifier, // Backend expects identifier in 'username' field
      password: password,
    });
    console.log('authService: Login API call successful', response.data);
    return response.data;
  } catch (error) {
    let errorMessage = "Login failed. Please check Email/Phone Number and Password."; // Updated default error
    if (error.response) {
        console.error("authService: Login failed - Response Error:", error.response.data);
        errorMessage = error.response.data?.error || error.response.data?.detail || `Login failed with status ${error.response.status}`;
    } else if (error.request) { errorMessage = "Login failed: No response from server.";
    } else { errorMessage = `Login failed: ${error.message}`; }
    throw new Error(errorMessage);
  }
};

export const signupUser = async (apiData) => {
    console.log('authService: Attempting signup with data (PIN excluded):', apiData);
    if (!apiData.username || !apiData.email || !apiData.password || !apiData.phone_number || !apiData.ref_code) {
        console.error("authService: Missing required signup data", apiData);
        throw new Error("Internal error: Missing required data for signup.");
    }
    try {
        const response = await apiClient.post('/account/signup/', apiData);
        console.log('authService: Signup API call successful', response.data);
        return response.data;
    } catch (error) {
       let errorMessage = "Registration failed. Please try again.";
       if (error.response) {
            console.error("authService: Signup failed - Response Error:", error.response.data);
            if (typeof error.response.data === 'object' && error.response.data !== null) {
                 const fieldErrors = Object.entries(error.response.data).map(([key, value]) => {
                     let fieldName = key.replace('_', ' '); let message = Array.isArray(value) ? value.join(', ') : value;
                     if (key === 'ref_code') return "Invalid Referrer Member ID provided.";
                     if (key === 'username') return "This name is already taken as a username.";
                     if (key === 'email') return "This email address is already registered.";
                     if (key === 'phone_number') return "This phone number is already registered.";
                     return `${fieldName}: ${message}`;
                 }).join('; ');
                 if (fieldErrors) errorMessage = fieldErrors;
                 else if (error.response.data.error) errorMessage = error.response.data.error;
                 else if (error.response.data.detail) errorMessage = error.response.data.detail;
             } else { errorMessage = `Registration failed with status ${error.response.status}`; }
       } else if (error.request) { errorMessage = "Signup failed: No response from server.";
       } else { errorMessage = `Signup failed: ${error.message}`; }
       throw new Error(errorMessage);
    }
};

export const activateUser = async (email, token) => {
    console.log('authService: Attempting activation for email:', email);
     try {
        const response = await apiClient.post('/account/activate/', { email, token });
        console.log('authService: Activation API call successful', response.data);
        return response.data;
     } catch (error) {
        let errorMessage = "Activation failed. Please check details.";
        if (error.response) {
             console.error("authService: Activation failed - Response Error:", error.response.data);
             errorMessage = error.response.data.error || error.response.data.detail || `Activation failed with status ${error.response.status}`;
             if (errorMessage.toLowerCase().includes('invalid or expired')) errorMessage = "Invalid or expired activation token.";
             else if (errorMessage.toLowerCase().includes('invalid email')) errorMessage = "Email address not found or doesn't match token.";
        } else if (error.request) { errorMessage = "Activation failed: No response from server.";
        } else { errorMessage = `Activation failed: ${error.message}`; }
        throw new Error(errorMessage);
     }
};

export const requestPasswordReset = async (email) => {
    console.log('authService: Requesting password reset for email:', email);
    const endpoint = '/account/reset-password/request/'; // Confirm endpoint
    const payload = { email: email };
    try {
        const response = await apiClient.post(endpoint, payload);
        console.log('authService: Password reset request successful', response.data);
        return response.data;
    } catch (error) {
        let errorMessage = "Failed to request password reset.";
         if (error.response) {
             console.error("authService: Request Password Reset failed - Response Error:", error.response.data);
             errorMessage = error.response.data.error || error.response.data.detail || `Password reset request failed: ${error.response.status}`;
             if (errorMessage.toLowerCase().includes('not found')) errorMessage = "No account found with that email address.";
         } else if (error.request) { errorMessage = "Password reset request failed: No response from server.";
         } else { errorMessage = `Password reset request failed: ${error.message}`; }
        throw new Error(errorMessage);
    }
};

export const confirmPasswordReset = async (token, newPassword) => {
  console.log('authService: Attempting password reset confirmation with token');
  const endpoint = '/account/reset-password/confirm/'; // Confirm endpoint
  // Confirm exact payload needed by backend (might need email too?)
  const payload = { token: token, password: newPassword };
  try {
      const response = await apiClient.post(endpoint, payload);
      console.log('authService: Password reset confirmation successful', response.data);
      return response.data;
  } catch (error) {
       let errorMessage = "Failed to reset password.";
       if (error.response) {
           console.error("authService: Reset Password Confirm failed - Response Error:", error.response.data);
           errorMessage = error.response.data.error || error.response.data.detail || `Password reset failed: ${error.response.status}`;
           if (errorMessage.toLowerCase().includes('invalid token')) errorMessage = "Invalid or expired password reset token.";
           else if (errorMessage.toLowerCase().includes('weak password')) errorMessage = "The new password is too weak.";
       } else if (error.request) {  errorMessage = "Password reset failed: No response from server.";
       } else {  errorMessage = `Password reset failed: ${error.message}`; }
      throw new Error(errorMessage);
  }
};

export const refreshToken = async (currentRefreshToken) => {
  console.log('authService: Attempting to refresh token...');
  const refreshEndpoint = '/token/refresh/'; // Confirm endpoint
  try {
      const response = await apiClient.post(refreshEndpoint, {
          refresh: currentRefreshToken,
      });
      console.log('authService: Token refresh successful', response.data);
      if (!response.data?.access) {
          throw new Error("Invalid response format from refresh token endpoint.");
      }
      return response.data;
  } catch (error) {
      console.error("authService: Failed to refresh token:", error.response?.data || error.message);
      throw error;
  }
};